import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoPecNotifichePecStep2Component
} from './conservazione-carica-documento-pec-notifiche-pec-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.conservazione-carica-documento-pec-notifiche-pec-step2', {
      url: '/conservazione-carica-pec-notifiche-pec',
      ncyBreadcrumb: {
        label: 'Carica PEC - Notifiche PEC',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      'views': {
        'homeContent': {
          template: '<conservazione-carica-documento-pec-notifiche-pec-step2 flex="100"></conservazione-carica-documento-pec-notifiche-pec-step2>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoPecNotifichePecStep2Module: string = ng
  .module('conservazione-carica-documento-pec-notifiche-pec-step2', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('conservazioneCaricaDocumentoPecNotifichePecStep2', ConservazioneCaricaDocumentoPecNotifichePecStep2Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-pec-notifiche-pec-step2/conservazione-carica-documento-pec-notifiche-pec-step2.module.ts